import { Component } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TeltonikaUpdateDefaultCredentials } from '@huge-monorepo/shared/interfaces';
import { SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { IHIPTeltonikaService, ICustomerTeltonikaService } from '@huge-monorepo/shared/interfaces';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'huge-monorepo-teltonika-update-default-credentials-modal',
  standalone: true,
  imports: [CommonModule, MaterialModule, ReactiveFormsModule],
  templateUrl: './teltonika-update-default-credentials-modal.component.html',
  styleUrl: './teltonika-update-default-credentials-modal.component.scss',
})
export class TeltonikaUpdateDefaultCredentialsModalComponent {
  usernameControl: FormControl = new FormControl(null, [Validators.required]);
  passwordControl: FormControl = new FormControl(null, [Validators.required]);
  teltonikaService = this.sharedTeltonikaService.getService();

  constructor(
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private toastr: ToastrService,
    private location: Location
  ) { }

  /**
   * 
   * It validates the username and password controls.
   * If either control is invalid, it marks the control as touched and exits the function.
   * If both controls are valid, it creates an update object with the username and password values.
   * The method updates the default Teltonika credentials using the `teltonikaService` 
   * and displays a success or error message using `toastr` based on the outcome of the update operation.
   * 
   * @returns void
   */
  updateCredentials(): void {
    if (this.usernameControl.invalid) {
      this.usernameControl.markAsTouched();
      return;
    }

    if (this.passwordControl.invalid) {
      this.passwordControl.markAsTouched();
      return;
    }

    const updateObj: TeltonikaUpdateDefaultCredentials = {
      Username: this.usernameControl.value,
      Password: this.passwordControl.value,
    };

    this.teltonikaService.updateDefaultTeltonikaCreds(updateObj).subscribe({
      next: () => {
        this.toastr.success('Default Credentials Updated');
        this.location.back(); // Navigate back after success
      },
      error: () => {
        this.toastr.error('Error Updating Default Credentials');
      }
    });
  }

  cancel(): void {
    this.location.back();
  }

}
